histories-task-created
  span.event {this.locale().event}
  span.created
    span.label.label-sm(style="background: {phaseColorCode()}") { phaseName() }
  script(type="typescript").
    this.mixin('histories.base');
